import { RootState } from '@checkout/state';
import { Field } from 'formik';
import * as React from 'react';
import { Fragment } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { PasswordField } from '..';
import { Button, InputField, Section } from '../../presentational';
import messages from './../../../i18n/base-en';

interface IOwnProps {
  showButton?: boolean;
}

interface IConnectedProps {}

interface IConnectetDispatchProps {}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class RegisterFields extends React.Component<Props, {}> {

  componentDidMount() {
    const loginField = document.getElementById('register.firstName');
    if (loginField) {
      loginField.focus();
    }
  }

  render() {
    const { showButton, intl } = this.props;
    const { formatMessage } = intl;

    return (
      <Fragment>
        <Section>
          <Field
            id="register.firstName"
            name="register.firstName"
            component={InputField}
            placeholder={formatMessage(messages.membership_firstname_placeholder)}
            label={formatMessage(messages.membership_firstname_label)}
            required={true}
            sizeVariant="half"
            type="text"
            submitOnEnter={true}
          />
          <Field
            id="register.lastName"
            name="register.lastName"
            component={InputField}
            placeholder={formatMessage(messages.membership_lastname_placeholder)}
            label={formatMessage(messages.membership_lastname_label)}
            required={true}
            sizeVariant="half"
            type="text"
            submitOnEnter={true}
          />
          <Field
            id="register.email"
            name="register.email"
            component={InputField}
            placeholder={formatMessage(messages.membership_email_placeholder)}
            label={formatMessage(messages.membership_email_label)}
            required={true}
            type="email"
            submitOnEnter={true}
            autoComplete="username email"
          />
          <Field
            id="register.password"
            name="register.password"
            component={PasswordField}
            iconTitle={formatMessage(messages.membership_show_password_tooltip)}
            placeholder={formatMessage(messages.membership_password_placeholder)}
            label={formatMessage(messages.membership_password_label)}
            required={true}
            sizeVariant="half"
            type="password"
            autoComplete="current-password"
            submitOnEnter={true}
          />
          <Field
            id="register.passwordConfirm"
            name="register.passwordConfirm"
            component={PasswordField}
            iconTitle={formatMessage(messages.membership_show_password_tooltip)}
            placeholder={formatMessage(messages.membership_password_confirm_placeholder)}
            label={formatMessage(messages.membership_password_confirm_label)}
            required={true}
            sizeVariant="half"
            type="password"
            autoComplete="off"
            submitOnEnter={true}
          />
        </Section>
        {showButton && (
          <Button
            type="submit"
            variant="primary"
            align="center"
            size="medium"
            width="long"
            label={formatMessage(messages.membership_register_continue_button_label)}
          />
        )}
      </Fragment>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({}),
    {}
  )
)(RegisterFields);
